export default __webpack_public_path__ + "static/media/greenStepCompleted.63d47733.svg";